"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MainHeader_1 = require("./MainHeader");
exports.default = MainHeader_1.default;
//# sourceMappingURL=index.js.map